import { fdrTextBgCriteria } from 'fdr/components/util/criterias/text-bg.dmc';

export const fdrThemeVars = {
  textBgImageCriteria: fdrTextBgCriteria,
};
